import { ListableString } from "./data";

export interface Account extends ListableString {
  country: string;
  type: string;
  org_number: string;
  address_line1: string;
  address_line2: string;
  address_city: string;
  address_region: string;
  address_postal_code: string;
}

export const AccountFields: string[] = [
  "name",
  "org_number",
  "address_line1",
  "address_line2",
  "address_postal_code",
  "address_region",
];
